export const SET_UNREAD_MESSAGE = 'store/tasia/SET_UNREAD_MESSAGE';
export const SET_SHOW_BADGE = 'store/tasia/SET_SHOW_BADGE';
